import { OpenAPIV2 } from 'openapi-types'

export const getReferenceKey = (it: OpenAPIV2.ReferenceObject): string => {
  return it.$ref.substring('#/definitions/'.length)
}

export const isReference = <T extends object>(
  it: T,
): it is T & OpenAPIV2.ReferenceObject => {
  return '$ref' in it && it.$ref === 'string'
}

export const followReference =
  (swaggerfiles: OpenAPIV2.Document) =>
  <T extends object>(it: T | OpenAPIV2.ReferenceObject): T => {
    if (!isReference(it)) return it

    const key = getReferenceKey(it)
    return swaggerfiles.definitions?.[key] as Exclude<
      T,
      OpenAPIV2.ReferenceObject
    >
  }
